import { processRequest } from '../../services/Api';
import { put, call, takeLatest, all } from 'redux-saga/effects';
import i18n from 'i18next';
import { bookDetailsActionTypes } from './Constants';
import * as bookDetailsActions from './Actions';
import * as notificationActions from '../../components/notification/Actions';
import * as errorHandlerActions from '../../components/errorHandler/Actions';

export default function* () {
	yield all([
		yield takeLatest(bookDetailsActionTypes.GET_BOOK_DETAILS_REQUEST, handleBookDetailsRequest),
		yield takeLatest(bookDetailsActionTypes.ADD_TO_MY_BOOKS_REQUEST, handleAddToMyBooksRequest),
		yield takeLatest(
			bookDetailsActionTypes.REMOVE_FROM_MY_BOOKS_REQUEST,
			handleRemoveFromMyBooksRequest,
		),
	]);
}

export function* handleBookDetailsRequest(action) {
	try {
		const { id } = action.payload;
		const { data } = yield call(processRequest, `public/books/${id}`);
		yield put(bookDetailsActions.getBookDetailsSuccess(data));
	} catch (e) {
		yield put(errorHandlerActions.handleError(e));
		yield put(bookDetailsActions.getBookDetailsError());
	}
}

export function* handleAddToMyBooksRequest({ payload }) {
	try {
		const { bookId, name, callback } = payload || {};

		const { data } = yield call(
			processRequest,
			`public/books/${bookId}/add_to_collection`,
			'PUT',
		);
		yield put(
			notificationActions.createNotification(
				i18n.t('components.book_card.added_notification', { bookName: name }),
				null,
				false,
				5000,
			),
		);
		yield put(bookDetailsActions.addToMyBooksSuccess(data.subject_books));

		if (callback) callback();
	} catch (e) {
		yield put(errorHandlerActions.handleError(e, 'notification'));
		yield put(bookDetailsActions.addToMyBooksError());
	}
}

export function* handleRemoveFromMyBooksRequest({ payload }) {
	try {
		const { bookId, name, callback } = payload || {};

		yield call(processRequest, `public/books/${bookId}/remove_from_collection`, 'DELETE');
		yield put(
			notificationActions.createNotification(
				i18n.t('components.book_card.removed_notification', { bookName: name }),
				null,
				false,
				5000,
			),
		);
		yield put(bookDetailsActions.removeFromMyBooksSuccess());
		if (callback) callback();
	} catch (e) {
		yield put(errorHandlerActions.handleError(e, 'notification'));
		yield put(bookDetailsActions.removeFromMyBooksError());
	}
}
